export default "__VITE_ASSET__BrbBVqRF__"